import { isProd, isUat } from "@/common/utilities/env";

export const getEnv = () => {
  if (isUat()) {
    return "uat";
  }

  if (isProd()) {
    return "prod";
  }

  return "dev";
};

export const getFirebaseStorageGenieAssetsRoot = () => {
  return `gs://genfive-${getEnv()}-assets`;
};

export const getNetworkAssetsRoot = (
  organizationId: number | string | undefined,
  networkId: number | string | undefined
) => {
  return `${getFirebaseStorageGenieAssetsRoot()}/organizations/${organizationId}/networks/upload/${networkId}`;
};

export const getDashboardAssetsRoot = (
  organizationId: number,
  workspaceId: number,
  dashboardId: number
) => {
  return `${getFirebaseStorageGenieAssetsRoot()}/organizations/${organizationId}/workspaces/${workspaceId}/dashboards/upload/${dashboardId}`;
};

export { CONTENT_RELEVANCE_SCORE_THRESHOLD } from "@/common/enums/relevance";
export const STAKEHOLDERS_SEMANTIC_RELEVANCE_SCORE_THRESHOLD = 0.7;

/** Large page size for non-paginated “fetch all / large batch” list queries. */
export const MAX_PAGE_SIZE = 500;

/**
 * How many stakeholders a multi-select may hold. The bulk actions behind the selection —
 * stakeholder groups above all — are bounded by the same number.
 */
export const STAKEHOLDER_SELECT_LIMIT = 500;

/** App-wide delay before a `SearchInput` auto-searches after the user stops typing. */
export const SEARCH_DEBOUNCE_DELAY_MS = 1000;

export const EMPTY_ARRAY: never[] = [];
// NOTE: We use never here so that when use with other record type it will not infer the value type as never,
// but instead will infer the value type from the other record type
// for example Record<string, string> ?? Record<string, never> will infer the value type as string
export const EMPTY_OBJECT: Record<string, never> = {};
export const EMPTY_FUNC_PLACEHOLDER = () => {};
